import Houdini from 'houdinijs';

const accordion = () => {
  const accordions = document.querySelectorAll(
    '[data-houdini-group]:not([data-houdini-group-facet])',
  );
  const accordionGroup = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < accordions.length; i++) {
    const groupName = accordions[i].getAttribute('data-houdini-group');
    if (!accordionGroup.includes(groupName)) {
      accordionGroup.push(groupName);

      // eslint-disable-next-line no-new
      new Houdini(`[data-houdini-group="${groupName}"]`, {
        isAccordion: true,
        collapseOthers: true,
        btnClass: 'c-accordion__toggle',
        iconShow:
          '<div class="c-accordion__toggle-icon"><svg>\n' +
          '          <use xlink:href="#icon-chevron-down"></use>\n' +
          '        </svg></div>',
        iconHide:
          '<div class="c-accordion__toggle-icon c-accordion__toggle-icon--close"><svg>\n' +
          '          <use xlink:href="#icon-chevron-down"></use>\n' +
          '        </svg></div>',
      });
    }
  }
};

accordion();

const accordionFacet = () => {
  const accordions = document.querySelectorAll('[data-houdini-group-facet]');
  const accordionGroup = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < accordions.length; i++) {
    const groupName = accordions[i].getAttribute('data-houdini-group');
    if (!accordionGroup.includes(groupName)) {
      accordionGroup.push(groupName);

      // eslint-disable-next-line no-new
      new Houdini(`[data-houdini-group="${groupName}"]`, {
        isAccordion: true,
        collapseOthers: true,
        btnClass: 'c-accordion__toggle',
        iconShow:
          '<div class="c-accordion__toggle-icon"><svg>\n' +
          '          <use xlink:href="#icon-chevron-down"></use>\n' +
          '        </svg></div>',
        iconHide:
          '<div class="c-accordion__toggle-icon c-accordion__toggle-icon--close"><svg>\n' +
          '          <use xlink:href="#icon-chevron-down"></use>\n' +
          '        </svg></div>',
      });
    }
  }
};

document.addEventListener('facetwp-loaded', () => accordionFacet());
